const routes = [
  // 消防管理-防火巡查项
  {
    path: "/repair/orderDistribute",
    name: "repairOrderDistribute",
    component: () => import("@src/modules/deviceRepair/view/orderDistribute"),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    path: "/repair/orderReceive",
    name: "repairOrderReceive",
    component: () => import("@src/modules/deviceRepair/view/orderReceive"),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  }
];

export default routes;
